import { AppProvider } from '@shopify/polaris';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import enTranslations from '@shopify/polaris/locales/en.json';
import '@shopify/polaris/build/esm/styles.css';

import { AppLayout } from './components/AppLayout';
import { Dashboard } from './routes/Dashboard';
import { Settings } from './routes/Settings';

/**
 * Main App component.
 *
 * App Bridge v4+ is automatically initialized via the script tag in index.html
 * when the app runs inside Shopify Admin. The `shopify-api-key` meta tag and
 * `host` URL parameter are read automatically by the CDN script.
 *
 * Access App Bridge features in child components via useAppBridge() hook
 * from @shopify/app-bridge-react.
 */
export default function App() {
  return (
    <AppProvider i18n={enTranslations}>
      <BrowserRouter>
        <Routes>
          <Route element={<AppLayout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/settings" element={<Settings />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}
